import { useDebounce } from "ahooks";
import { Select } from "antd";
import { useMemo, useState } from "react";
import { IInputTreeProps } from "../../../../../components/input";
import { ObjectUtils } from "../../../../../modules/utils";
import useRoute from "../hooks/use-route";

const SelectRoute = (props: IInputTreeProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const [, setDropdownOpen] = useState<boolean>(false);

  const keywordDebounce = useDebounce(keyword, {
    wait: 500,
  });

  const {
    data: routeList,
    isLoading: isLoadingRoute,
    isFetching: isFetchingRoute,
  } = useRoute({
    keySearch: keywordDebounce || undefined,
  });

  const options = useMemo(() => {
    const asyncResponse = routeList;
    const errorMessage = ObjectUtils.getIn(asyncResponse, "Error.Message");

    if (!asyncResponse || errorMessage) {
      return [];
    }

    const data = ObjectUtils.getIn(asyncResponse, "Data", []);
    return data
      .filter((item: any) => item.AirportCode)
      .map((item: any) => ({
        label: `${item.AirportCode} - ${item.CityName_VN}`,
        value: item.AirportCode,
        title: item.AirportName,
      }));
  }, [routeList]);

  const handleSearch = (value: string) => {
    setKeyword(value);
  };

  const handleChange = (value: any) => {
    props.onChange(value);
    props.onTouched(true);
  };

  const handleDropdownVisibleChange = (open: boolean) => {
    setDropdownOpen(open);
    if (!open) {
      setKeyword("");
    }
  };

  const loading = (isLoadingRoute || isFetchingRoute) && Boolean(keywordDebounce);
  const notFoundContent = loading
    ? "Đang tải..."
    : keywordDebounce
    ? "Không tìm thấy tuyến"
    : "Nhập từ khóa để tìm kiếm";

  // Extract compatible props from treeProps if needed
  const compatibleProps = props.treeProps
    ? {
        className: props.treeProps.className,
        size: props.treeProps.size,
        style: props.treeProps.style,
      }
    : {};

  return (
    <Select
      {...compatibleProps}
      className="middle"
      value={props.value}
      onChange={handleChange}
      onBlur={() => props.onTouched(true)}
      placeholder={props.placeholder || "* Chọn tuyến"}
      disabled={props.isDisabled || props.isLoading}
      allowClear
      showSearch
      onSearch={handleSearch}
      loading={loading}
      options={options}
      notFoundContent={notFoundContent}
      filterOption={false} // Tắt filter phía client vì đã filter ở server
      onDropdownVisibleChange={handleDropdownVisibleChange}
      dropdownMatchSelectWidth
      style={{ width: "100%", ...compatibleProps.style }}
    />
  );
};

export default SelectRoute;
